import apiClient from '@/services/axios'

export async function post(payload) {
  var response = await apiClient.post('/rewards', payload)
  if (response) {
    return response.data
  }

  throw new Error('Unable to add reward.')
}